<template>
  <div class="ranking-rule" :class="{ 'rule_rtl': language === 'ar' }" :style="{ backgroundImage: `url(${bg})` }">
    <div class="ranking-rule__closeAr" @click="handleClose" v-if="language === 'ar'">
      <img fr src="@/assets/img/starlightChallenge/rule-close-btn.png" alt="close" />
    </div>
    <div class="ranking-rule__close" @click="handleClose" v-else>
      <img fr src="@/assets/img/starlightChallenge/rule-close-btn.png" alt="close" />
    </div>
    <div class="ranking">
      <div class="ranking-boxzh" :style="{ backgroundImage: `url(${content})` }" v-if="language === 'zh'"></div>
      <div class="ranking-box" :style="{ backgroundImage: `url(${content})` }" v-else></div>
    </div>
  </div>
</template>

<script lang='ts'>
import { getRequestLanguage } from '@/api/utils'
import { SetupContext, nextTick, ref } from 'vue'
import { Popup } from 'vant'

export default {
  name: 'GiftRankingRule',
  emits: ['onClose'],
  components: {
    [Popup.name as string]: Popup
  },
  setup(props: any, context: SetupContext) {
    const handleClose = () => {
      context.emit('onClose', false)
    }
    // const language = computed(() => {
    //   return getRequestLanguage()
    // })
    const rankingDiv = ref<Element | null>(null)
    nextTick(() => {
      if (rankingDiv.value) {
        rankingDiv.value.scrollLeft -= 10 // 将滚动条位置向左移动10px
      }
    })
    let language = getRequestLanguage()
    if (language.indexOf('zh') > -1) {
      if (language.indexOf('Hant') > -1 || language.indexOf('Hans') > -1) {
        language = 'zh'
      }
      language = 'zh'
    }

    const bg = require(`@/../src/assets/img/starlightChallenge/rule-bg-${language}.png`)
    let content = require(`@/../src/assets/img/starlightChallenge/rule-content-${language}.png`)
    const isMe = ['stableMe', 'stableSa', 'productionMe', 'productionSa'].includes(process.env.VUE_APP_ENV || 'development')
    if (isMe && language === 'en') {
      content = require('@/../src/assets/img/starlightChallenge/me-rule-content-en.png')
    } else if (isMe && language === 'zh') {
      content = require('@/../src/assets/img/starlightChallenge/me-rule-content-zh.png')
    }
    return {
      handleClose,
      language,
      content,
      bg
    }
  }

}
</script>
<style lang='scss' scoped>
.rule_rtl {
  direction: rtl;
  @include b(ranking-box) {
    margin-right: 6px;
    margin-top: 20px;
    position: relative;
    width: 680px;
    height: 1550px;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
.ranking {
  // overflow-y: auto;
  margin: 0 auto;
  overflow-y: auto;
  overflow-x: hidden;
  height: 680px;
  width: 90%;
  // background-color: #5ece8f;
  /* 设置滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
    background-color: #626a99;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
    border-radius: 4px;
  }
}
.ranking-rule {
  width: 760px;
  height: 760px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: visible;
  padding-top: 120px;
}
@include b(ranking-box) {
  margin-left: 6px;
  margin-top: 20px;
  position: relative;
  width: 680px;
  height: 1550px;
  background-size: contain;
  background-repeat: no-repeat;
}
@include b(ranking-boxzh) {
  margin-left: 6px;
  margin-top: 20px;
  position: relative;
  width: 680px;
  height: 1100px;
  background-size: contain;
  background-repeat: no-repeat;
}

.ranking-rule__close {
  position: absolute;
  top: 8%;
  right: 20px;
  width: 60px;
  height: 60px;
  z-index: 9999;
}
.ranking-rule__closeAr {
  position: absolute;
  top: 8%;
  left: 20px;
  width: 60px;
  height: 60px;
  z-index: 9999;
}
</style>
